// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"a677dd8a","156":"a31f658e","219":"790fcdc8","371":"9bbeb4ea","453":"5d9d47fd","597":"ca1075d4","909":"e0ec1544"}[chunkId] + ".chunk.js";
};